export const environment = {
    baseUrl: 'https://pb.dev.knoot-academy.de',
    production: false,
};
